<template>
    <div id="banner">
        <div class="bannerContainer center-block" >
            <img :src="url" alt="" class="img-responsive center-block">
            <div v-if="showBtn" class="btn_groups">
                <el-button class="btn btn-success"  :disabled="disable" data-toggle="modal" data-target="#myModal">登录</el-button>
                <button class="btn btn-default" @click="toAuth">企业申请认证</button>
            </div>

            <div v-if="showDownload"  class="btn_groups1" style="height: 100%">
                <div>
                    <div class="text">
                        <p style="text-align: left">微解药震撼上线！</p>
                        <p style="text-align: left">微解药 我要的知识和服务</p>
                        <div style="width: 100%;margin: 30px auto 0">
                            <div style="display: inline-block">
                                <img src="../../../static/images/ios_code.png" alt="ios下载二维码">
                            </div>
                            <div style="display: inline-block;margin-left: 20px;" class="btnContainer">
                                <button @click="toIos"><img src="../../../static/images/ios.svg" alt="">AppStore下载</button>
                                <button @click="toAndriod" style="transform: translateY(20px)"><img src="../../../static/images/android.svg" alt="">Android下载</button>
                            </div>

                        </div>
                    </div>
                </div>
               <div class="phone" style="height: 100%">
                   <img src="../../../static/images/bannerphone.png" alt="">
               </div>

            </div>
        </div>
        <!-- 登录（Modal） -->
        <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                    <div class="modal-content">
                        <form id="myModalLabelForm">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                                <h4 class="modal-title" id="myModalLabel" style="text-align: center">企业登录</h4>
                            </div>
                            <div class="modal-body">
                                <el-form :model="userForm" ref="userForm" label-width="0px" :rules="rules">
                                    <el-form-item prop="mobile">
                                        <el-input type="text" v-model="userForm.mobile" placeholder="请您输入手机号码" ></el-input>
                                    </el-form-item>
                                    <el-form-item prop="sms_code">
                                        <el-row>
                                            <el-col :span="18">
                                                <el-input type="text" style="width:95%;" v-model="userForm.sms_code" placeholder="请您输入验证码" ></el-input>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-button  :disabled="userForm.mobile === '' || logindisable" style="float:right;width:100%" type="primary" plain @click="sendLoginCode">{{buttonTexts}}</el-button>
                                            </el-col>
                                        </el-row>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" style="width:100%; background-color:#00b1b4; border-color:#fff" @click="submitForm">登录</el-button> 
                                        <p class="toRegister" @click="toRegister">没有账号？先去注册</p>
                                   </el-form-item>
                                </el-form>
                            </div>
                        </form>
                    </div><!-- /.modal-content -->
            </div><!-- /.modal -->
        </div>
        <!-- （Modal） -->
        <div class="modal fade" id="registerModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                            <h4 class="modal-title" id="myModalLabel" style="text-align: center">企业注册</h4>
                        </div>
                        <div class="modal-body">
                            <el-form :model="registerForm" ref="registerForm" :rules="rules" label-width="0px">
                                <el-form-item prop="mobile">
                                    <el-input type="text" v-model="registerForm.mobile" name="mobile" auto-complete="on" placeholder="请您输入手机号码" ></el-input>
                                </el-form-item>
                                <el-form-item prop="sms_code">
                                    <el-row>
                                        <el-col :span="18">
                                            <el-input type="text" style="width:95%;" v-model="registerForm.sms_code" name="sms_code" auto-complete="on" placeholder="请您输入验证码" ></el-input>
                                        </el-col>
                                        <el-col :span="6">
                                            <el-button  :disabled="registerForm.mobile === '' || disable" style="float:right;width:100%" type="primary" plain @click="sendCode">{{buttonText}}</el-button>
                                        </el-col>
                                    </el-row>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" style="width:100%; background-color:#00b1b4; border-color:#fff" @click="submitRegister">注册</el-button> 
                                    <p class="toRegister" @click="toLogin">直接登录</p>
                                    <p class="agreement">注册代表你已经同意<a href="#" @click="agreement">用户协议及隐私政策</a></p>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div><!-- /.modal-content -->
            </div><!-- /.modal -->
        </div>
       <div id="userAgreement" class="modal fade bs-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <h4 class="modal-title" id="myModalLabel" style="text-align: center">微解药用户注册协议</h4>
                </div>
                <Useprotocol/>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
    import md5 from 'js-md5'
    import { truncate } from 'fs';
    import Useprotocol from '@/components/Useprotocol'
    import { fetchMobile, sendCode, register, login, getAuthstatus } from '@/api/login'
    import { getUserInfo } from '@/api/auth'
    import { setToken, setUid, getUid } from '@/utils/index'
    export default {
        name: "banner",
        components: {
            Useprotocol
        },
        data() {
            return {
                registerForm: {
                    mobile: '',
                    sms_code: '',
                },
                disable: false,
                userForm: {
                    mobile: '',
                    sms_code: '',
                },
                disable: false,
                logindisable: false,
                timer: null,
                num : 60,
                loginNum: 60,
                buttonText: '发送验证码',
                buttonTexts: '发送验证码',
                rules: {
                    mobile: {
                        required: true, message: '请输入手机号', trigger: 'blur'
                    },
                    sms_code: {
                        required: true, message: '请输入验证码', trigger: 'blur'
                    }
                }
            }
        },

        methods:{
            toAndriod(){
                window.open('https://www.weijieyao.com/download/app-release.apk')
            },
            toIos(){
                window.open('https://itunes.apple.com/us/app/微解药/id1405530893?l=zh&ls=1&mt=8')
            },
            agreement() {
                $('#userAgreement').modal('show')
            },
            async toAuth() {
                const uid = getUid()
                if (uid) {          
                    const { data } = await getUserInfo(uid)
                    if(data.data.company_user.company_auth_status === "unsubmitted") {
                        this.$router.push({
                            name:'Authentication',
                            params: data.data.company_user,
                        })
                    } else if(data.data.company_user.company_auth_status === "success") {
                        window.location.href = process.env.ADMIN_URL
                    } else {
                        this.$router.push({
                            name:'Authstatus',
                            params: data.data.company_user,
                        })
                    }
                } else {
                    return this.$message.success('没有登录，请您先注册登陆') 
                }
                
            },
            // 发送验证码
            async sendCode() {
                const { data } = await fetchMobile(this.registerForm.mobile)
                if (data.data.exist === 0) {   
                    const rest = {
                        'mobile': this.registerForm.mobile,
                        'type': 'register'
                    }
                    const { data } = await sendCode(rest)
                    if (data.code === 200 ) {
                        this.num = 60
                        this.timer = setInterval(() => {
                            if (this.num > 0 && this.num <= 60) {
                                this.disable = true
                                this.num--;
                                this.buttonText = `重新发送(${this.num}s)`
                            } else {
                                clearInterval(this.timer);
                                this.timer = null;
                                this.disable = false
                                this.buttonText = "重新发送"
                            }
                        }, 1000)
                    }
                    return this.$message.success(data.msg) 
                }
            },
            async sendLoginCode() {
                const rest = {
                    'mobile': this.userForm.mobile,
                    'type': 'login'
                }
                const { data } = await sendCode(rest)
                if(data.code === 200 ) {
                    this.loginNum = 60
                    this.timer = setInterval(() => {
                        if (this.loginNum > 0 && this.loginNum <= 60) {
                            this.logindisable = true
                            this.loginNum--;
                            this.buttonTexts = `重新发送(${this.loginNum}s)`
                        } else {
                            clearInterval(this.timer);
                            this.timer = null;
                            this.logindisable = false
                            this.buttonTexts = "重新发送"
                        }
                    }, 1000)
                }
                return this.$message.success(data.msg)
            },
            toRegister() {
                $('#myModal').modal('hide')
                $('#registerModal').modal('show')
            },
            toLogin() {
                $('#myModal').modal('show')
                $('#registerModal').modal('hide')
            },
            submitForm() {
                this.$refs.userForm.validate(async valid => {
                    if (!valid) {
                        return
                    }
                    const fromData = this.userForm
                    const { data } = await login(fromData)
                    if (data.code === 200) {
                        $('#myModal').modal('hide')
                        setToken(data.data.sessionKey)
                        setUid(data.data.company_user._id)
                        if(data.data.company_user.company_auth_status === "unsubmitted") {
                            this.$router.push({
                                name:'Authentication',
                                params: data.data.company_user,
                            })
                        } else if(data.data.company_user.company_auth_status === "success") {
                           window.location.href = process.env.ADMIN_URL
                        } else {
                            this.$router.push({
                                name:'Authstatus',
                                params: data.data.company_user,
                            })
                        }
                    }
                })
            },
            submitRegister() {
                this.$refs.registerForm.validate(async valid => {
                    if (!valid) {
                        return
                    }
                    const fromData = this.registerForm
                    const { data } = await register(fromData)
                    if (data.code === 200) {
                        $('#myModal').modal('show')
                        $('#registerModal').modal('hide')
                        this.$refs.registerForm.resetFields()
                        this.$refs.userForm.resetFields()
                        this.$refs.registerForm.clearValidate()
                        this.$refs.userForm.clearValidate()
                    } else {
                        this.$refs.registerForm.resetFields()
                    }
                })
            },
        },
        props:[
            'url','showBtn','showDownload'
        ],
        mounted(){
            const uid = getUid()
            if (uid) { 
                this.disable = true
            }
        }

    }
</script>

<style scoped lang="scss">
    .el-input__inner{
      border-radius:0 0 4px 4px;
    }
    .modal-body{
        padding: 10px 50px;
    }
    .toRegister{
        cursor: pointer;
        width:100%;
        text-align: center;
        color:#666;
    }
    .agreement{
        color: #ccc;
        font-size: 12px;
        text-align: left;
        a{
            cursor: pointer;
        }
    }
    @media screen and (min-width: 1201px) and (max-width: 1439px){
        .text{
            width: 60%;
            color: #fff;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            >div{
                >div{

                    button{
                        width: 100%;
                        height: 100%;
                        outline: none;
                        border: 1px solid #fff;
                        background-color: transparent;
                        img{
                            width: 24px;
                            height: 27px;
                            margin-right: 5px;
                        }
                    }
                    >img{
                        width: 148px;
                        height: 148px;
                    }
                }
                >.btnContainer{
                    transform: translateY(15px);
                    width:196px;
                    height: 58px;
                }
            }
            p:nth-child(1){
                font-size: 56px!important;
                text-align: center;
            }
            p:nth-child(2){
                font-size: 30px;
                text-align: center;
            }
        }
    }
    @media screen and (max-width:768px){
        .btn{
            width: 70px!important;
            height: 25px!important;
            font-size: 14px!important;
            line-height: 25px!important;
            padding: 0!important;
            outline: none;
        }
        #banner{
            .bannerContainer{
                .btn_groups{
                    bottom: 30px !important;
                }
            }
            .btn-success{
                margin-right: 0!important;
            }
            .input-gp{
                input{
                    width: 150px!important;
                }
            }
        }
    }
    #banner{
        width: 100%;
        .bannerContainer{
            position: relative;
            width: 100%;
            overflow: hidden;
            .btn_groups{
                width: 75%;
                position: absolute;
                left: 51%;
                transform: translate(-50%);
                bottom:20%;
                z-index: 99;
            }
            .btn_groups1{
                width: 75%;
                position: absolute;
                left: 51%;
                transform: translate(-50%);
                bottom:0;
                z-index: 99;
                .text{
                    width: 60%;
                    color: #fff;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    >div{
                        >div{

                            button{
                                width: 100%;
                                height: 100%;
                                outline: none;
                                border: 1px solid #fff;
                                background-color: transparent;
                                img{
                                    width: 24px;
                                    height: 27px;
                                    margin-right: 5px;
                                }
                            }
                            >img{
                                width: 148px;
                                height: 148px;
                            }
                        }
                        >.btnContainer{
                            transform: translateY(15px);
                            width:196px;
                            height: 58px;
                            button{
                                &:hover{
                                    background: #00b1b4;
                                    border-color: #00b1b4 ;
                                }
                            }
                        }
                    }
                    p:nth-child(1){
                        font-size: 76px;
                        text-align: center;
                    }
                    p:nth-child(2){
                        font-size: 38px;
                        text-align: center;
                    }
                }
                .phone{
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    img{
                        height: 80%;
                        position: absolute;
                        bottom: 0;
                        right: 0;
                    }
                }
            }
        }
        .btn{
            width: 170px;
            height: 50px;
            font-size: 24px;
            outline: none;
        }
        .btn-success{
            margin-right: 10px;
            background-color: #00b1b4;
            border-color: transparent;
            color: #fff;
            // &:hover{
            //    background-color: #fff;
            //     color: #00b1b4;
            // }
        }
        .btn-default{
            background-color: transparent;
            border-color: #00b1b4;
            color: #fff;
            &:hover{
                background-color: #fff;
                color: #00b1b4;
                border-color: #fff;
            }
        }
        .input-gp{
            width: 80%;
            height: 45px;
            border: 1px solid #ccc;
            margin: 0 auto;
            border-radius: 30px;
            img{
                width: 34px;
                height: 27px;
                margin-left: 14px;
                margin-top: 8px;
                padding-right: 10px;
                border-right: 1px solid #ccc;
            }
            input{
                height: 27px;
                margin-left: 14px;
                transform: translate(0,5px);
                width: 250px;
                outline: none;
                border: 0;
            }
        }
        .btns{
            text-align: center;
            line-height: 45px;
            background-color: #16b1b3;
            color: #fff;
            cursor: pointer;
        }
        .modal-header{
            border-bottom: none;
        }
        .modal-footer{
            border-top: none;
        }
        textarea{
            display: block;
            width: 80%;
            height: 75px;
            border-radius: 5px;
            border-color: #ccc;
            margin: 20px  auto 0;
            outline: none;
            text-indent: 14px;
            resize:none;
        }
        .alert{
            padding: 0!important;
        }
        .message{

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/banner.vue